// extracted by mini-css-extract-plugin
export default {"recordButton":"RecordButton_recordButton__8ziaA","pulse":"RecordButton_pulse__1bcfA","hithere":"RecordButton_hithere__U1k1J"};